import React, { useEffect } from 'react';
import { useSendPershingConfirmationStatus } from 'src/api/atv/atvApi';
import PershingError from '../handlers/PershingErrorPage';
import PershingSpinner from './PershingSpinner';

interface PershingConfirmationStatusProps {
  confirmationNumber: string;
  onSuccess: (confirmationNumber: string, status: string) => void;
}

const PershingConfirmationStatus: React.FC<PershingConfirmationStatusProps> = ({
  confirmationNumber,
  onSuccess,
}) => {
  const [sendPershingConfirmationStatus, { data: pershingData, isLoading, error }] =
    useSendPershingConfirmationStatus();

  useEffect(() => {
    try {
      if (confirmationNumber) {
        sendPershingConfirmationStatus({
          confirmationNumber: confirmationNumber,
        });
      }
    } catch (fetchError) {
      console.error('Error fetching Pershing confirmation status:', fetchError);
    }
  }, [sendPershingConfirmationStatus, confirmationNumber]);

  useEffect(() => {
    if (pershingData?.confirmationNumber && !error) {
      onSuccess(pershingData.confirmationNumber, pershingData.status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pershingData]);

  if (isLoading) {
    return <PershingSpinner />;
  }

  if (error) {
    return <PershingError />;
  }

  return null;
};

export default PershingConfirmationStatus;
